import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ModalFooter, ModalHeader } from './common';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
  saving?: boolean;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  isOpen,
  title,
  message,
  onSave,
  onDiscard,
  onCancel,
  saving = false,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('unsavedChanges.defaultTitle', { ns: 'common' });
  const resolvedMessage = message ?? t('unsavedChanges.defaultMessage', { ns: 'common' });

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-[rgba(26,23,20,0.45)] px-4 py-6"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md overflow-hidden rounded-[24px] border border-[#E2DDD8] bg-[#FFFFFF] shadow-[0_24px_60px_rgba(26,23,20,0.24)]"
        onClick={(event) => event.stopPropagation()}
      >
        <ModalHeader
          eyebrow={t('unsavedChanges.eyebrow', { ns: 'common' })}
          title={<h3 className="font-['Playfair_Display',Georgia,serif] text-[24px] font-semibold text-[#1A1714]">{resolvedTitle}</h3>}
          description={resolvedMessage}
        />

        <ModalFooter className="py-5">
          <Button
            type="button"
            onClick={onCancel}
            disabled={saving}
            variant="outline"
          >
            {t('buttons.keepEditing', { ns: 'common' })}
          </Button>
          <Button
            type="button"
            onClick={onDiscard}
            disabled={saving}
            variant="secondary"
          >
            {t('buttons.discardChanges', { ns: 'common' })}
          </Button>
          <Button
            type="button"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? t('status.saving', { ns: 'common' }) : t('buttons.saveChanges', { ns: 'common' })}
          </Button>
        </ModalFooter>
      </div>
    </div>
  );
};
